<template>
  <v-app>
    <v-main
      :style="`background-image: url(${require('../../assets/background.jpg')})`"
      class="mybackground"
    >
      <v-container fill-height>
        <v-row>
          <v-col>
            <router-link to="/login">
              <v-btn
                v-if="authForm === 'forgotPassword'"
                text
              >&leftarrow; Back</v-btn>
            </router-link>
            <v-card
              class="pb-10 pt-5 pr-5 pl-5"
              color="rgb(10, 16, 61, 0.5)"
              width="400"
              outlined
            >
              <v-card-title class="text-h4 font-weight-bold" style="word-break:break-word">{{titleText}}</v-card-title>
              <v-card-text class="text-left">{{descriptionText}}</v-card-text>
              <div class="pr-5 pl-5">
                <div v-if="authForm === 'signUp'">
                  <div v-if="signUpStep === 1">
                    <v-text-field
                      v-model="email"
                      dense
                      outlined
                      label="Email Address"
                      placeholder="you@example.com"
                      hide-details
                      @blur="handleInputBlur(`forms.signUp.email`)"
                      @input="hideValidationErrorMsg(`forms.signUp.email`)"
                    ></v-text-field>
                    <ValidationErrorMsg :validation-data="getInputValidationData(`forms.signUp.email`)" />
                    <v-text-field
                      v-model="password"
                      class="mt-2"
                      dense
                      outlined
                      label="Password"
                      placeholder="********"
                      hide-details
                      type="password"
                      @blur="handleInputBlur(`forms.signUp.password`)"
                      @input="hideValidationErrorMsg(`forms.signUp.password`)"
                    ></v-text-field>
                    <ValidationErrorMsg :validation-data="getInputValidationData(`forms.signUp.password`)" />
                    <v-checkbox
                      class="mt-1"
                      small
                      hide-details
                      v-model="agreementCheck"
                    >
                      <template v-slot:label>
                        <span class="text-body-2">I agree to the <a href="">Terms and conditions</a></span>
                      </template>
                    </v-checkbox>
                    <ValidationErrorMsg :validation-data="getInputValidationData(`forms.${authForm}.agreementCheck`)" />
                    <v-btn
                      @click="signUp"
                      class="mt-4"
                      block
                      large
                      color="primary"
                      :loading="isLoading"
                    >Create Account</v-btn>
                  </div>
                  <div v-if="signUpStep === 2">
                    <v-text-field
                      v-model="verificationCode"
                      dense
                      outlined
                      label="Code"
                      placeholder="XXXXXX"
                      hide-details
                      @blur="handleInputBlur(`forms.confirmSignUp.verificationCode`)"
                      @input="hideValidationErrorMsg(`forms.confirmSignUp.verificationCode`)"
                    ></v-text-field>
                    <ValidationErrorMsg :validation-data="getInputValidationData(`forms.confirmSignUp.verificationCode`)" />
                    <v-btn
                      @click="confirmSignUp"
                      class="mt-4"
                      block
                      large
                      color="primary"
                      :loading="isLoading"
                    >Confirm email</v-btn>
                  </div>
                </div>
                <div v-if="authForm === 'signIn'">
                  <div v-if="signInStep === 1">
                    <v-text-field
                      v-model="email"
                      dense
                      outlined
                      label="Email Address"
                      placeholder="you@example.com"
                      hide-details
                      @blur="handleInputBlur(`forms.signIn.email`)"
                      @input="hideValidationErrorMsg(`forms.signIn.email`)"
                    ></v-text-field>
                    <ValidationErrorMsg :validation-data="getInputValidationData(`forms.signIn.email`)" />
                    <v-text-field
                      v-model="password"
                      class="mt-2"
                      dense
                      outlined
                      label="Password"
                      placeholder="********"
                      hide-details
                      type="password"
                      @blur="handleInputBlur(`forms.signIn.password`)"
                      @input="hideValidationErrorMsg(`forms.signIn.password`)"
                    ></v-text-field>
                    <ValidationErrorMsg :validation-data="getInputValidationData(`forms.signIn.password`)" />
                    <v-btn
                      @click="signIn"
                      class="mt-4"
                      block
                      large
                      color="primary"
                      :loading="isLoading"
                    >Login</v-btn>
                  </div>
                  <div v-if="signInStep === 2">
                    <v-text-field
                      v-model="verificationCode"
                      class="mt-2"
                      dense
                      outlined
                      label="Code"
                      placeholder="XXXXXX"
                      hide-details
                      @blur="handleInputBlur(`forms.confirmSignInMfa.verificationCode`)"
                      @input="hideValidationErrorMsg(`forms.confirmSignInMfa.verificationCode`)"
                    ></v-text-field>
                    <ValidationErrorMsg :validation-data="getInputValidationData(`forms.confirmSignInMfa.verificationCode`)" />
                    <v-btn
                      @click="confirmSignInMfa"
                      class="mt-4"
                      block
                      large
                      color="primary"
                      :loading="isLoading"
                    >Login</v-btn>
                  </div>
                </div>
                <div v-if="authForm === 'forgotPassword'">
                  <div v-if="forgotPasswordStep === 1">
                    <v-text-field
                      v-model="email"
                      dense
                      outlined
                      label="Email Address"
                      placeholder="you@example.com"
                      hide-details
                      @blur="handleInputBlur(`forms.forgotPasswordSendCode.email`)"
                      @input="hideValidationErrorMsg(`forms.forgotPasswordSendCode.email`)"
                    ></v-text-field>
                    <ValidationErrorMsg :validation-data="getInputValidationData(`forms.forgotPasswordSendCode.email`)" />
                    <v-btn
                      @click="forgotPasswordSendCode"
                      class="mt-4"
                      block
                      large
                      color="primary"
                      :loading="isLoading"
                    >Send code</v-btn>
                  </div>
                  <div
                    v-if="forgotPasswordStep === 2"
                    align="center"
                  >
                    <v-text-field
                      v-model="verificationCode"
                      class="mt-2"
                      dense
                      outlined
                      label="Code"
                      placeholder="XXXXXX"
                      hide-details
                      @blur="handleInputBlur(`forms.${authForm}.verificationCode`)"
                      @input="hideValidationErrorMsg(`forms.${authForm}.verificationCode`)"
                    ></v-text-field>
                    <ValidationErrorMsg :validation-data="getInputValidationData(`forms.${authForm}.verificationCode`)" />
                    <v-text-field
                      v-model="password"
                      class="mt-2"
                      dense
                      outlined
                      label="New Password"
                      placeholder="********"
                      hide-details
                      type="password"
                      @blur="handleInputBlur(`forms.${authForm}.password`)"
                      @input="hideValidationErrorMsg(`forms.${authForm}.password`)"
                    ></v-text-field>
                    <ValidationErrorMsg :validation-data="getInputValidationData(`forms.${authForm}.password`)" />
                    <v-btn
                      @click="resetPassword"
                      class="mt-4"
                      block
                      large
                      color="primary"
                      :loading="isLoading"
                    >Reset password</v-btn>
                    <v-btn
                      class="ml-0 pl-2"
                      small
                      text
                      @click="forgotPasswordSendCode"
                    >
                      Or click here to resend code
                    </v-btn>
                  </div>
                </div>
                <div
                  v-if="authForm === 'signUp'"
                  class="my-2 text-subtitle"
                  align="center"
                >
                  <router-link
                    v-if="signUpStep === 1"
                    to="/login"
                  >Already have an account? Login here.</router-link>
                  <v-btn
                    v-if="signUpStep === 2"
                    class="ml-0 pl-2"
                    small
                    text
                    @click="resendConfirmSignUp"
                  >
                    Or click here to resend code
                  </v-btn>
                </div>
                <div
                  v-if="authForm === 'signIn'"
                  class="my-2 text-subtitle"
                  align="center"
                >
                  <router-link to="/reset-password">Forgot password</router-link> |
                  <router-link to="/signup">Create account</router-link>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col></v-col>
        </v-row>
        <v-snackbar
          v-model="snackbar.show"
          top
          :color="snackbar.color"
        >
          {{ snackbar.text }}
          <template v-slot:action="{ attrs }">
            <v-btn
              color="white"
              text
              v-bind="attrs"
              @click="snackbar.show = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { Auth } from 'aws-amplify';
import ValidationErrorMsg from '../../components/ValidationErrorMsg.vue'
import { validateValues, _get, _set } from '../../helpers/validation.js';

export default {
  props: ['authForm'],
  components: {
    ValidationErrorMsg,
  },
  data: () => ({
    email: "",
    password: "",
    agreementCheck: false,
    isLoading: false,
    snackbar: {
      text: "",
      color: "",
      show: false,
    },
    signUpStep: 1,
    signInStep: 1,
    forgotPasswordStep: 1,
    verificationCode: "",
    forms: {
      signUp: {
        email: {
          path: "email",
          validationRulesPath: "emailRules",
          showErrorMsg: false,
        },
        password: {
          path: "password",
          validationRulesPath: "passwordRules",
          showErrorMsg: false,
        },
        agreementCheck: {
          path: "agreementCheck",
          validationRulesPath: "agreementCheckRules",
          showErrorMsg: false,
        }
      },
      confirmSignUp: {
        verificationCode: {
          path: "verificationCode",
          validationRulesPath: "verificationCodeRules",
          showErrorMsg: false,
        },
      },
      signIn: {
        email: {
          path: "email",
          validationRulesPath: "emailRules",
          showErrorMsg: false,
        },
        password: {
          path: "password",
          validationRulesPath: "passwordRules",
          showErrorMsg: false,
        },
      },
      confirmSignInMfa: {
        verificationCode: {
          path: "verificationCode",
          validationRulesPath: "verificationCodeRules",
          showErrorMsg: false,
        },
      },
      forgotPasswordSendCode: {
        email: {
          path: "email",
          validationRulesPath: "emailRules",
          showErrorMsg: false,
        },
      },
      forgotPassword: {
        verificationCode: {
          path: "verificationCode",
          validationRulesPath: "verificationCodeRules",
          showErrorMsg: false,
        },
        password: {
          path: "password",
          validationRulesPath: "passwordRules",
          showErrorMsg: false,
        },
      }
    },
  }),
  computed: {
    titleText() {
      if (this.authForm === 'signUp' && this.signUpStep === 1) return 'Create Account'
      if (this.authForm === 'signUp' && this.signUpStep === 2) return 'Confirm Email'
      if (this.authForm === 'signIn' && this.signInStep === 1) return 'Welcome Back'
      if (this.authForm === 'signIn' && this.signInStep === 2) return '2-Factor Authentication'
      if (this.authForm === 'forgotPassword') return 'Reset Password'
    },
    descriptionText() {
      if (this.authForm === 'signUp' && this.signUpStep === 1) return 'Join the fastest growing cryptocurrency brokerage today.'
      if (this.authForm === 'signUp' && this.signUpStep === 2) return 'Please enter the 6-digit code sent to your email below.'
      if (this.authForm === 'signIn' && this.signInStep === 1) return 'Please login with your personal account information below.'
      if (this.authForm === 'signIn' && this.signInStep === 2) return 'Please enter the 6-digit code from your authentication app.'
      if (this.authForm === 'forgotPassword' && this.forgotPasswordStep === 1) return 'Enter your email below and we`ll send you a link to reset your password.'
      if (this.authForm === 'forgotPassword' && this.forgotPasswordStep === 2) return `We've sent a 6-digit code to your email. Please enter the code and your new password below.`
    },
    emailRules() {
      return [
        {
          name: 'required',
          validateRule: function (val, rule) {
            return rule.validate(val);
          }
        },
        {
          name: 'email',
          validateRule: function (val, rule) {

            return rule.validate(val)
          }
        }
      ]
    },
    passwordRules() {
      let authForm = this.authForm
      return [
        {
          name: 'required',
          validateRule: function (val, rule) {
            return rule.validate(val)
          }
        },
        {
          name: 'password',
          validateRule: function (val, rule) {
            let result = rule.validate(val)
            if (authForm === 'signIn') result.msg = 'Invalid password.'
            return result
          }
        }
      ]
    },
    agreementCheckRules() {
      return [
        {
          name: 'required',
          validateRule: function (val, rule) {
            let result = rule.validate(val)
            result.msg = 'You must agree.'
            return result
          }
        }
      ]
    },
    verificationCodeRules() {
      return [
        {
          name: 'required',
          validateRule: function (val, rule) {
            return rule.validate(val)
          }
        },
        {
          name: 'numbersOnlyExact',
          validateRule: function (val, rule) {
            let result = rule.validate(val, 6)
            result.msg = 'Code must be 6 digits.'
            return result
          }
        },
      ]
    }
  },
  methods: {
    handleInputBlur(inputMetadataPath) {
      let { inputMetadata, val } = this.getInputValidationData(inputMetadataPath);
      inputMetadata.showErrorMsg = true;
      if (inputMetadata === null) {
        return;
      }
      if (val === null || val === undefined) {
        _set(this, inputMetadata.path, "");
      }
    },
    getInputValidationData(inputMetadataPath) {
      let inputMetadata = _get(this, inputMetadataPath);
      if (!inputMetadata) console.log("Couldn't find this path:", inputMetadataPath);
      let val = _get(this, inputMetadata.path);
      let rules = _get(this, inputMetadata.validationRulesPath);
      return { inputMetadata, val, rules };
    },
    hideValidationErrorMsg(inputMetadataPath) {
      let { inputMetadata } = this.getInputValidationData(inputMetadataPath);
      inputMetadata.showErrorMsg = false;
    },
    showValidationErrorMsgsByForm(formMetadataName) {
      let formMetadata = _get(this, formMetadataName);
      for (const item of Object.values(formMetadata)) {
        item.showErrorMsg = true;
      }
    },
    validateInputsByForm(formMetadataName) {
      let formMetadata = _get(this, formMetadataName);
      // sanitizing form
      for (const key of Object.keys(formMetadata)) {
        let inputMetadata = formMetadata[key];
        let val = _get(this, inputMetadata.path);
        if (typeof (val) !== 'boolean') {
          val = val === null || val === undefined ? "" : val;
          val = val.trim();
        }
        _set(this, inputMetadata.path, val);
      }
      // validating form
      let valueAndRulesArray = Object.keys(formMetadata).map((i) => {
        let inputMetadata = formMetadata[i];
        let value = _get(this, inputMetadata.path);
        let rules = _get(this, inputMetadata.validationRulesPath);
        return { value, rules };
      });
      return validateValues(valueAndRulesArray);
    },
    async signUp() {
      let isFormValid = this.validateInputsByForm('forms.signUp');
      if (!isFormValid) {
        this.showValidationErrorMsgsByForm('forms.signUp');
        return;
      }
      this.isLoading = true
      try {
        const { user } = await Auth.signUp({
          username: this.email,
          password: this.password,
          attributes: {
            email: this.email,
            'custom:createdAt': new Date(),
          }
        });
        this.$store.commit('auth/setUser', user)
        console.log('user from signUp()', user)
        this.signUpStep = 2
      } catch (error) {
        this.snackbarError(error)
      }
      this.isLoading = false
    },
    async confirmSignUp() {
      this.isLoading = true
      try {
        await Auth.confirmSignUp(this.email, this.verificationCode);
        await Auth.signIn(this.email, this.password);
        this.$router.push('/dashboard')
      } catch (error) {
        this.snackbarError(error)
      }
      this.isLoading = false
    },
    async resendConfirmSignUp() {
      try {
        await Auth.resendSignUp(this.email);
        this.snackbarSuccess('Code was resent to your email.')
      } catch (error) {
        this.snackbarError(error)
      }
    },
    async signIn() {
      const isFormValid = this.validateInputsByForm('forms.signIn')
      if (!isFormValid) {
        this.showValidationErrorMsgsByForm('forms.signIn');
        return;
      }
      this.isLoading = true
      try {
        const user = await Auth.signIn(this.email, this.password);
        console.log('challengeName',user.challengeName)
        if (user.challengeName) {
          this.signInStep = 2
        }
        if (!user.challengeName) {
          this.$store.commit('auth/setUser', user)
          this.$router.push('/dashboard')
        }
      } catch (error) {
        this.snackbarError(error)
      }
      this.isLoading = false
    },
    async confirmSignInMfa() {
      const isFormValid = this.validateInputsByForm('forms.confirmSignInMfa')
      if (!isFormValid) {
        this.showValidationErrorMsgsByForm('forms.confirmSignInMfa');
        return;
      }
      this.isLoading = true
      try {
        const user = await Auth.signIn(this.email, this.password);
        const loggedUser = await Auth.confirmSignIn(
          user,
          this.verificationCode,
          'SOFTWARE_TOKEN_MFA'
        );
        this.$store.commit('auth/setUser', loggedUser)
        this.$router.push('/dashboard')
      } catch (error) {
        console.log(error)
        this.snackbarError(error)
      }
      this.isLoading = false
    },
    forgotPasswordSendCode() {
      let isFormValid = this.validateInputsByForm('forms.forgotPasswordSendCode');
      if (!isFormValid) {
        this.showValidationErrorMsgsByForm('forms.forgotPasswordSendCode');
        return;
      }
      Auth.forgotPassword(this.email)
        .then(
          data => {
            console.log(data)
            if (this.forgotPasswordStep === 1) this.forgotPasswordStep = 2
            this.snackbarSuccess('Code was sent to your email.')
          })
        .catch(
          error => {
            this.snackbarError(error)
          });
    },
    resetPassword() {
      let isFormValid = this.validateInputsByForm('forms.forgotPassword');
      if (!isFormValid) {
        this.showValidationErrorMsgsByForm('forms.forgotPassword');
        return;
      }
      Auth.forgotPasswordSubmit(this.email, this.verificationCode, this.password)
        .then(data => {
          console.log(data)
          this.snackbarSuccess('Your password was reset. Please login again.')
          this.$router.push('/login')
        })
        .catch(error => {
          console.log(error)
          this.snackbarError(error)
        });
    },
    snackbarError(msg) {
      this.snackbar.show = true
      this.snackbar.color = 'red'
      this.snackbar.text = msg
    },
    snackbarSuccess(msg) {
      this.snackbar.show = true
      this.snackbar.color = 'green'
      this.snackbar.text = msg
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
a:link {
  text-decoration: none;
}
a:visited {
  color: white;
}
a:hover {
  color: rgb(45, 178, 255);
}
</style>